// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import GoalModalController from "./goal_modal_controller"
application.register("goal-modal", GoalModalController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RepeatRuleController from "./repeat_rule_controller"
application.register("repeat-rule", RepeatRuleController)

import MenuController from "./menu_controller";
application.register("menu", MenuController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import PetCommentController from "./pet_comment_controller";
application.register("pet-comment", PetCommentController);